import { useEffect } from 'react';
import { EventRegistrationOptionAvailability } from 'src/generated/api/dsv-public/model';
import { CustomAxiosConfig } from 'src/dsv-api-axios-instance';
import { useSessionStore } from 'src/stores/session-store';

export function useAvailabilityStream(eventId: number): void {
  const updateAvailability = useSessionStore(state => state.updateAvailability);
  const sessionId = useSessionStore(state => state.sessionId);

  useEffect(() => {
    const handleData = (rawData: string) => {
      try {
        const parsed = JSON.parse(rawData);
        const updates: EventRegistrationOptionAvailability[] = Array.isArray(parsed) ? parsed : [parsed];
        updateAvailability(updates);
      } catch {
        // Ignore malformed SSE events
      }
    };

    const base = `${CustomAxiosConfig.baseUrl}/public/api/events/${eventId}/registration/availability`;
    const url = sessionId ? `${base}?sessionId=${encodeURIComponent(sessionId)}` : base;
    const es = new EventSource(url);
    const availabilityHandler = (me: MessageEvent) => handleData(me.data);
    es.addEventListener('availability', availabilityHandler);
    es.onmessage = (me: MessageEvent) => handleData(me.data);

    return () => es.close();
  }, [eventId, sessionId, updateAvailability]);
}
